import tmhRequest from '@/config/tmhRequest'

export default {
    initCashier: function (data) {
        return tmhRequest({
            url: '/order/ispa/cashier/initcashier',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/order/cashier.js